import { render, staticRenderFns } from "./toolDescribe.vue?vue&type=template&id=85c58924&scoped=true&"
import script from "./toolDescribe.vue?vue&type=script&lang=js&"
export * from "./toolDescribe.vue?vue&type=script&lang=js&"
import style0 from "./toolDescribe.vue?vue&type=style&index=0&id=85c58924&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c58924",
  null
  
)

export default component.exports